var _Circle, _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg";
var SvgRegistrationLink = function SvgRegistrationLink(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#4285F4"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#clip0_3981_3028)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "white"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M26.984 39.203c0 .418.175.837.49 1.152l2.164 1.954a8.853 8.853 0 0 0 6.354 2.688c2.374 0 4.643-.943 6.354-2.653a8.956 8.956 0 0 0 2.653-6.352 8.956 8.956 0 0 0-2.654-6.353l-2.06-2.06a1.643 1.643 0 0 0-1.151-.488c-.42 0-.838.174-1.153.488a1.643 1.643 0 0 0-.488 1.152c0 .419.174.838.488 1.152l2.06 2.06c1.083 1.081 1.676 2.512 1.676 4.083 0 1.571-.593 3.002-1.676 4.084-1.082 1.082-2.513 1.676-4.084 1.676a5.758 5.758 0 0 1-4.085-1.675l-2.06-2.06a1.644 1.644 0 0 0-1.152-.489c-.419 0-.838.175-1.152.489-.35.314-.524.698-.524 1.152Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M24.85 26.49c0 .42.174.838.488 1.152l6.948 6.911c.663.664 1.675.664 2.304 0a1.6 1.6 0 0 0 0-2.268l-6.948-6.912a1.643 1.643 0 0 0-1.151-.488c-.42 0-.838.174-1.153.488-.279.315-.454.698-.488 1.117Z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M30.117 21.981c.314.314.733.489 1.152.489.419 0 .838-.175 1.152-.489a1.601 1.601 0 0 0 0-2.269l-2.06-2.06C28.651 15.908 26.381 15 24.007 15a8.927 8.927 0 0 0-6.354 2.618C15.943 19.328 15 21.597 15 23.97c0 2.373.943 4.642 2.653 6.352l2.06 2.06c.664.663 1.676.663 2.304 0 .314-.315.489-.733.489-1.152 0-.419-.175-.838-.489-1.152l-2.06-2.06c-1.082-1.081-1.675-2.513-1.675-4.083 0-1.571.593-3.002 1.675-4.084 1.083-1.082 2.514-1.676 4.085-1.676 1.536 0 3.002.594 4.085 1.676l1.99 2.129Z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "clip0_3981_3028"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "white",
    transform: "translate(15 15)",
    d: "M0 0h30v29.997H0z"
  })))));
};
export default SvgRegistrationLink;